import { getWidthPercents } from '../../utils';

export const Heading = (text: string) => (index: number)  => `
<mj-column width="${getWidthPercents(index)}" padding="0">
    <mj-text color="#444444" padding="0">
        <p style="font-size: 19px; font-weight: bold;">${text}</p>
    </mj-text>
</mj-column>
`;
